import { BREAKPOINTS } from '@/config/layout.config'

/**
 * Get the current window width
 * @returns {number} window width
 */
export const getWindowWidth = (): number => (
  typeof window !== 'undefined' ? window.innerWidth : 0
)

/**
 * Check if the current viewport is mobile
 * @returns {boolean}
 */
export const isMobile = (): boolean => (
  typeof window !== 'undefined' && window.matchMedia(`(max-width:${BREAKPOINTS.sm}px)`).matches
)
